// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}

.PostContent {
    max-width: 700px;
    text-align: left;
}

.PostContent img {
    max-width: -webkit-fill-available;;
    display: block;
    margin: 0 auto;
    margin-left: auto;
    margin-right: auto;
    border-radius: 32px;
}`, "",{"version":3,"sources":["webpack://./src/css/PostDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".PostContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.PostContent {\n    max-width: 700px;\n    text-align: left;\n}\n\n.PostContent img {\n    max-width: -webkit-fill-available;;\n    display: block;\n    margin: 0 auto;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
